import {
  Cancel,
  CheckCircle,
  CloseOutlined,
  ExpandMore,
  ExpandMoreSharp,
  InfoOutlined,
} from "@mui/icons-material";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  alpha,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  InputAdornment,
  List,
  ListItem,
  ListItemText,
  MenuItem,
  Select,
  Stack,
  TextField,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useState } from "react";
import ReactJson from "react-json-view";
import Instructions from "./instructions";
import { LoadingButton } from "@mui/lab";

const CustomButton = ({
  label,
  error,
  handleClick,
  acc,
  setOpenSnackbar,
  value,
}) => {
  const [open, setOpen] = useState(false);
  const [domain, setDomain] = useState("godaddy");
  const [service, setService] = useState("google");
  const [subDomain, setSubDomain] = useState("");
  const [subDomainError, setSubDomainError] = useState("");
  const [checking, setChecking] = useState(false);

  const theme = useTheme();

  const isSmDown = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const isValidDomain = (subdomain) => {
    const regex = /[^a-zA-Z0-9\-]/;
    return subdomain !== "" ? !regex.test(subdomain) : false;
  };
  const handleOpen = () => [setOpen(true)];
  const handleClose = () => {
    setOpen(false);
  };
  const [expandedSpf, setExpandedSpf] = useState(true);
  const handleExpandSPF = () => {
    setExpandedSpf(!expandedSpf);
  };

  const checkStatus = () => {
    if (isValidDomain(subDomain)) {
      setSubDomainError("");
      setChecking(true);
      setTimeout(() => setChecking(false), 5000);
    } else {
      setSubDomainError("Invalid sub domain!");
    }
  };
  const CustomDomainInstructions = () => {
    return (
      <List
        sx={{
          listStyle: "decimal",
          pl: 4,
          "& .MuiListItem-root": { p: 0, fontSize: "14px" },
          "& .MuiListItemText-root .MuiTypography-root": {
            fontWeight: "400",
            fontSize: "14px",
            color: "#ffffff",
          },
        }}
      >
        <ListItem sx={{ display: "list-item" }}>
          <ListItemText>Go to your domain's DNS Settings</ListItemText>
        </ListItem>
        <ListItem sx={{ display: "list-item" }}>
          <ListItemText>Create a new CNAME record</ListItemText>
        </ListItem>
        <ListItem sx={{ display: "list-item" }}>
          <ListItemText>Enter the following details</ListItemText>
        </ListItem>
      </List>
    );
  };
  return (
    <>
      <IconButton
        onClick={
          ["SPF", "DMARC", "DKIM", "Custom Tracking", "MX"].includes(label)
            ? handleOpen
            : handleClick
        }
        sx={{ p: 0 }}
      // variant="outlined"
      // sx={{
      //   display: "flex",
      //   justifyContent: "center",
      //   alignItems: "center",
      //   gap: 1,
      //   borderRadius: 1,
      //   py: 1,
      //   px: 2,
      //   border: `1px solid ${error ? "#E20E0E" : "#00AA38"}`,
      //   "&:hover": {
      //     border: `1px solid ${error ? "#E20E0E" : "#00AA38"}`,
      //     backgroundColor: alpha(error ? "#E20E0E" : "#00AA38", 0.1),
      //   },
      // }}
      // className="glass-button-secondary-25"
      >
        {/* <Typography
          sx={{
            fontWeight: "700",
            color: theme.palette.text.primary,
            fontSize: "12px",
          }}
        >
          {label}
        </Typography> */}
        {error ? (
          <Cancel sx={{ color: "#E20E0E", fontSize: "22px" }} />
        ) : (
          <CheckCircle sx={{ color: "#00AA38", fontSize: "22px" }} />
        )}
      </IconButton>
      <Dialog open={open} onClose={handleClose} fullScreen={isSmDown}>
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h6" sx={{ color: theme.palette.text.primary }}>
            {label === "Custom Tracking"
              ? "Set up a custom tracking subdomain"
              : "Configure Domain Authentication"}
          </Typography>
          <IconButton onClick={handleClose}>
            <CloseOutlined sx={{ color: theme.palette.text.primary }} />
          </IconButton>
        </DialogTitle>
        <DialogContent
          sx={{
            overflow: { xs: "hidden", sm: "auto" },
            // flex: {
            //   xs: `${label === "Custom Tracking" ? 0 : 1} 1 auto`,
            //   sm: "1 1 auto",
            // },
          }}
        >
          {label === "Custom Tracking" ? (
            <Stack rowGap={2}>
              <Typography
                className=""
                sx={{
                  fontSize: "14px",
                  fontWeight: "400",
                  color: theme.palette.text.primary,
                }}
              >
                Default tracking domains can put your sending reputation at
                risk, so it's best to set up a custom tracking subdomain to
                maintain deliverability.
              </Typography>
              <Typography
                sx={{
                  fontSize: "14px",
                  fontWeight: "400",
                  color: theme.palette.text.primary,
                }}
              >
                Configuring a custom subdomain will require access to your
                company's DNS.
              </Typography>
              <Stack rowGap={0.7}>
                <Typography
                  sx={{
                    fontSize: "14px",
                    fontWeight: "600",
                    color: theme.palette.text.primary,
                  }}
                >
                  Add custom subdomain
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: { xs: "column", sm: "row" },
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                    gap: 1,
                  }}
                >
                  <TextField
                    variant="outlined"
                    size="small"
                    sx={{ width: { xs: "100%", sm: "100px" }, flexGrow: 1 }}
                    className="glass-input"
                    value={subDomain}
                    onChange={(e) => setSubDomain(e.target.value)}
                    error={!!subDomainError}
                    placeholder={"track"}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <Typography
                            sx={{
                              fontSize: "14px",
                              fontWeight: "400",
                              color: theme.palette.text.primary,
                            }}
                          >
                            .{acc?.senderEmail.split("@")?.[1]}
                          </Typography>
                        </InputAdornment>
                      ),
                    }}
                    helperText={subDomainError}
                  />
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: 1,
                    }}
                  >
                    <LoadingButton
                      variant="contained"
                      loading={checking}
                      // loadingPosition="start"
                      loadingIndicator="Checking…"
                      sx={{ borderRadius: 1, py: "6px" }}
                      onClick={checkStatus}
                    >
                      <span>Check Status</span>
                    </LoadingButton>
                    {checking && (
                      <Button
                        variant="outlined"
                        sx={{ borderRadius: 1, py: "6px" }}
                        onClick={() => {
                          setChecking(false);
                        }}
                      >
                        Cancel
                      </Button>
                    )}
                  </Box>
                </Box>
              </Stack>
              <Stack rowGap={1}>
                <Typography
                  sx={{
                    color: theme.palette.text.primary,
                    fontSize: "14px",
                    fontWeight: "400",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  Add a new CNAME record for your tracking domain or subdomain.{" "}
                  <Tooltip title={<CustomDomainInstructions />}>
                    <InfoOutlined
                      sx={{
                        color: theme.palette.text.secondary,
                        fontSize: "18px",
                      }}
                    />
                  </Tooltip>
                </Typography>

                <Stack
                  rowGap={1}
                  sx={{
                    backgroundColor: alpha("#000000", 0.05),
                    borderRadius: 1,
                    p: 1,
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-start",
                      alignItems: "center",
                      gap: 1,
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: "14px",
                        fontWeight: "600",
                        color: theme.palette.text.primary,
                        width: "100px",
                      }}
                    >
                      Record Type:
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: "14px",
                        fontWeight: "400",
                        color: theme.palette.text.primary,
                      }}
                    >
                      CNAME
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-start",
                      alignItems: "center",
                      gap: 1,
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: "14px",
                        fontWeight: "600",
                        color: theme.palette.text.primary,
                        width: "100px",
                      }}
                    >
                      Host:
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: "14px",
                        fontWeight: "400",
                        color: theme.palette.text.primary,
                      }}
                    >
                      {subDomain || "track"}
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-start",
                      alignItems: "center",
                      gap: 1,
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: "14px",
                        fontWeight: "600",
                        color: theme.palette.text.primary,
                        width: "100px",
                      }}
                    >
                      Value:
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: "14px",
                        fontWeight: "400",
                        color: theme.palette.text.primary,
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      prox.itrackly.com{" "}
                      <span
                        style={{
                          borderRadius: "8px",
                          padding: "4px 8px",
                          marginLeft: "8px",
                          backgroundColor: theme.palette.text.primary,
                          color: "#ffffff",
                          fontSize: "13px",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          setOpenSnackbar(true);
                          navigator.clipboard.writeText("prox.itrackly.com");
                        }}
                      >
                        Copy
                      </span>
                    </Typography>
                  </Box>
                </Stack>
              </Stack>
            </Stack>
          ) : (
            <>
              <Typography
                sx={{
                  fontSize: "14px",
                  fontWeight: "600",
                  color: theme.palette.text.primary,
                  mt: 1,
                }}
              >
                {["SPF", "DKIM", "DMARC", "MX"].includes(label) && (
                  <>
                    <div style={{ margin: "0px" }}>
                      <Accordion
                        variant="outlined"
                        className="glass-wrapper-50"
                      >
                        <AccordionSummary
                          expandIcon={<ExpandMore />}
                          aria-controls="panel1-content"
                          id="panel1-header"
                        >
                          {label} Record
                        </AccordionSummary>
                        <AccordionDetails>
                          {/* {acc?.rapidApiData ? (
                            typeof acc?.rapidApiData !== "object" ? (
                              <Typography
                                sx={{ color: theme.palette.text.primary }}
                              >
                                {acc?.rapidApiData}
                              </Typography>
                            ) : (
                              <ReactJson
                                src={acc?.rapidApiData?.records[label]}
                              />
                            )
                          ) : (
                            <CircularProgress />
                          )} */}

                          <Typography
                            sx={{
                              color: (theme) => theme.palette.text.primary,
                              fontSize: "14px",
                              whiteSpace: "normal",
                              wordBreak: "break-word",
                              overflowWrap: "anywhere",
                              "& div, span, svg": {
                                color: (theme) =>
                                  `${theme.palette.text.primary} !important`,
                              },
                            }}
                          >
                            {value ? (
                              typeof value !== "object" ? (
                                value
                              ) : (
                                <ReactJson src={value} />
                              )
                            ) : (
                              "N/A"
                            )}
                          </Typography>
                        </AccordionDetails>
                      </Accordion>
                    </div>
                  </>
                )}
                How to configure domain attributes?{" "}
                <span
                  style={{
                    display: isSmDown ? "inline" : "none",
                    borderRadius: "8px",
                    padding: "4px",
                    border: `1px solid ${error ? "#E20E0E" : "#00AA38"}`,
                    fontSize: "14px",
                    fontWeight: "500",
                    marginLeft: "8px",
                  }}
                >
                  {" "}
                  {label}
                </span>
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                  gap: 1,
                  my: 1,
                }}
              >
                {" "}
                <Typography
                  sx={{
                    display: { xs: "none", sm: "block" },
                    borderRadius: 1,
                    py: 1,
                    px: 2,
                    border: `1px solid ${error ? "#E20E0E" : "#00AA38"}`,
                    fontSize: "14px",
                    fontWeight: "500",
                    color: theme.palette.text.primary,
                  }}
                  className="glass-pane"
                >
                  {label}
                </Typography>
                <Select
                  value={domain}
                  onChange={(e) => setDomain(e.target.value)}
                  size="small"
                  className="glass-dropdown"
                >
                  <MenuItem value="godaddy">GoDaddy</MenuItem>
                  <MenuItem value="namecheap">NameCheap</MenuItem>
                  <MenuItem value="other">Other</MenuItem>
                </Select>
                <Select
                  value={service}
                  onChange={(e) => setService(e.target.value)}
                  size="small"
                  className="glass-dropdown"
                >
                  <MenuItem value="google">Google WorkSpace</MenuItem>
                  <MenuItem value="microsoft">Microsoft 365</MenuItem>
                  <MenuItem value="other">Other</MenuItem>
                </Select>
              </Box>
              <Instructions
                domain={domain}
                service={service}
                type={label}
                rapiddata={acc.rapidApiData}
              />
            </>
          )}
        </DialogContent>
        {label === "Custom Tracking" && (
          <DialogActions>
            <Button
              fullWidth={isSmDown}
              variant="contained"
              sx={{ alignSelft: "end", borderRadius: 1 }}
              onClick={checkStatus}
            >
              Save
            </Button>
          </DialogActions>
        )}
      </Dialog>
    </>
  );
};

export default CustomButton;
